import { connect } from "react-redux";
import withHOC from "../../HOC/HOC";
import { bindActionCreators } from "redux";
import React from "react";
import FinancialInformation from "./FinancialInformation";
import { loanUpdateAction, setFinancialInformationAction, setIncomeDataAction, updateInvalidFormFieldAction } from "../CreateLoan/CreateLoanAction";
import { OPERATION_STATUS } from "../../config/axios.init";
import UserNotification from "../CustomUIComponents/UserNotification/UserNotification";
import { Row } from "react-bootstrap";
import { Strings } from "../../resources/i18n/i18n";
class FinancialInformationContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: "",
            toShowToast: false,
            successToastMessage: "",
            level: "",
        }
    }
    scrollToTop = () => {
        window.scrollTo(0, 0);
      };
    callAPI = (financialInformation, callback) => {
        this.scrollToTop();
        const incomeRequestData = {
            minimartId: this.props.singleMiniMart.id,
            loanApplicationId: this.props.applyLoanConfig.loanApplicationId,
            income: {
                monthlyIncome: null,
                monthlySalesAmount: financialInformation.monthlySalesAmount,
                accountsPending: financialInformation.accountsPending,
                inventory: financialInformation.inventory,
            }
        };
        const expensesRequestData = {
            minimartId: this.props.singleMiniMart.id,
            loanApplicationId: this.props.applyLoanConfig.loanApplicationId,
            expenses: {
                numberOfEmployees: financialInformation.numberOfEmployees,
                salaryOfEmployees: financialInformation.salaryOfEmployees,
                rent: financialInformation.rent,
                electricity: financialInformation.electricity,
                water: financialInformation.water,
                telephone: financialInformation.telephone,
                internet: financialInformation.internet,
                gas: financialInformation.gas,
                debtsToSuppliers: financialInformation.debtsToSuppliers,
            }
        }
        this.props.showLoadingModal();
        loanUpdateAction(incomeRequestData, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                this.props.closeLoadingModal();
                callback("");
                this.props.updateInvalidFormFieldAction("EXPENSES");
                this.props.updateInvalidFormFieldAction("INCOME");
                this.callUpdateExpensesAPI(expensesRequestData, callback);

            } else {
                this.scrollToTop();
                callback(response.error?.message);
                this.props.closeLoadingModal();
                this.props.updateInvalidFormFieldAction("EXPENSES");
                this.props.updateInvalidFormFieldAction("INCOME");
            }
        })

    }

    callUpdateExpensesAPI = (expenses, callback) => {
        this.props.showLoadingModal();
        loanUpdateAction(expenses, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                callback("");
                this.setState({
                    toShowToast: true,
                    successToastMessage: Strings("loanFormUpdatedSuccessfully"),
                    level: "success",
                }, () => {
                    setTimeout(() => {
                        this.props.closeLoadingModal();
                        this.props.handleNext();
                    }, 1000);
                });
            } else {
                this.scrollToTop();
                callback(response.error?.message);
                this.props.closeLoadingModal();
            }
        })
    }

    render() {
        return (
            <Row>
                {this.state.toShowToast && (
                    <UserNotification
                        key={this.state.successToastMessage}
                        userNotificationObj={{
                            message: this.state.successToastMessage,
                            level: this.state.level,
                        }}
                    />
                )}
                <FinancialInformation
                    financialInfoList={this.props.financialInfoList}
                    expensesLists={this.props.expensesLists}
                    goNext={this.props.handleNext}
                    goBack={this.props.handleBack}
                    callAPI={this.callAPI}
                    loanApplicationDetails={this.props.loanApplicationDetails}
                    financialInfoDetails={this.props.financialInfoDetails}
                    expenses={this.props.expenses}
                    income={this.props.income}
                    setIncomeDataAction={this.props.setIncomeDataAction}
                    setFinancialInformationAction={this.props.setFinancialInformationAction}
                    disableTextField={this.props.disableTextField}
                    errorMessage={this.state.errorMessage}
                    invalidFormField={this.props.invalidFormField}
                    showLoadingModalState={this.props.showLoadingModalState}
                    scrollToTop={this.scrollToTop}
                    selectedLoanType={this.props.selectedLoanType}
                />
            </Row>
        )
    }
}
const mapStateToProps = (state) => ({
    singleMiniMart: state.minimartListReducer.singleMiniMart,
    loanApplicationId: state.loanDetailsReducer.loanApplicationId,
    allLoanDetails: state.loanDetailsReducer.allLoanDetails,
    financialInfoDetails: state.loanDetailsReducer.financialInfoDetails,
    expenses: state.loanDetailsReducer.expenses,
    income: state.loanDetailsReducer.income,
    applyLoanConfig: state.loanDetailsReducer.applyLoanConfig,
    invalidFormField: state.loanDetailsReducer.invalidFormField,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            setFinancialInformationAction,
            setIncomeDataAction,
            updateInvalidFormFieldAction,
        },
        dispatch
    );
};
const FinancialInformationContainerWrapper = withHOC(FinancialInformationContainer);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FinancialInformationContainerWrapper);